"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var SignIn_1 = __importDefault(require("./SignIn"));
var SignUp_1 = __importDefault(require("./SignUp"));
var api_1 = require("../services/api");
// TODO: expire tokens and perform health check
var setSessionToken = function (token) {
    sessionStorage.setItem("JWT", token);
};
var login = function (params, setToken, authCallback) {
    authCallback(params)
        .then(function (response) {
        return response.json().then(function (json) {
            var token = json.token;
            if (token) {
                setSessionToken(token);
                setToken(token);
            }
        });
    })
        .catch(function (err) {
        console.log("error from login", err);
    });
};
function Login(_a) {
    var setToken = _a.setToken, token = _a.token, isLoginPage = _a.isLoginPage;
    var _b = (0, react_1.useState)({
        email: "",
        username: "",
        password: "",
    }), formState = _b[0], setFormState = _b[1];
    function handleChange(e) {
        var _a;
        var _b = e.currentTarget, name = _b.name, value = _b.value;
        setFormState(__assign(__assign({}, formState), (_a = {}, _a[name] = value, _a)));
    }
    var link;
    var FormComponent;
    var submitApi;
    if (isLoginPage) {
        link = (react_1.default.createElement(react_router_dom_1.Link, { className: "auth-link", to: "/register" }, "Need an account?"));
        FormComponent = SignIn_1.default;
        submitApi = api_1.login;
    }
    else {
        link = (react_1.default.createElement(react_router_dom_1.Link, { className: "auth-link", to: "/login" }, "Already have an account?"));
        FormComponent = SignUp_1.default;
        submitApi = api_1.register;
    }
    return token ? (react_1.default.createElement(react_router_dom_1.Redirect, { to: "/" })) : (react_1.default.createElement("div", { className: "login-page" },
        react_1.default.createElement("h4", null, "Todoozer"),
        react_1.default.createElement("form", { onSubmit: function (event) {
                event.preventDefault();
                login(formState, setToken, submitApi);
            } },
            react_1.default.createElement(FormComponent, { handleChange: handleChange })),
        link));
}
exports.default = Login;
